<template>
  <div class="wy-interactions-contact-reasons-page-action-buttons">
    <div class="overlapping-header">
      <div class="col-left info"><span v-if="parent.enableCompareMetrics">{{this.controller.tableModel.selectedRows.length}} selected</span></div>
      <div class="col-right">
        <div v-if="isRoleAllow(4601)&&controller.taskId" class="button section">
          <el-button class="primary-btn save-topic-btn" :disabled="!parent.enableActionButtons" @click.native="handleSaveNewTopic">
            <span class="button-text">Save selected topics</span>
          </el-button>
          <el-button class="primary-btn add-existing-topic-btn" :disabled="!parent.enableActionButtons" @click.native="handleAddToExistingTopic">
            <span class="button-text">Add to existing topic</span>
          </el-button>
          <el-button class="primary-btn add-existing-topic-btn" :disabled="!parent.enableMergeTopics" @click.native="handleMergeTopics">
            <span class="button-text">Merge into new topic</span>
          </el-button>
          <el-button class="primary-btn see-more-btn" :disabled="!parent.enableActionButtons" @click.native="handleMoreBtns">
           <el-dropdown ref="buttonPopupMenu" trigger="click" placement="bottom-end" class="btns-pop-over-menu">
              <div class="button-text see-more-btn">...</div>
              <el-dropdown-menu slot="dropdown" class="interactions-dashboard-btns-dropdown-menu">
                <!-- <el-dropdown-item @click.native="handleMergeTopics">Merge into new topic</el-dropdown-item> -->
                <el-dropdown-item @click.native="handleCompareMetrics">Compare topics</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </el-button>
        </div>
         <div v-else class="button section">
          <el-button class="primary-btn save-topic-btn" :disabled="!parent.enableCompareMetrics" @click.native="handleCompareMetrics">
            <span class="button-text">Compare topics</span>
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';


export default {
  name: 'wy-interactions-contact-reasons-page-header',
  props: ['controller', 'parent'],
  data() {
    return {
      buttons: [
        { name: 'compareMetrics', label: 'Compare AI-Generated Topics' },
        { name: 'mergeTopics', label: 'Group AI-Generated Topics' },
        { name: 'export', label: 'Export' }
      ]
    }
  },

  computed: {
    ...mapGetters(['isRoleAllow'])
  },

  methods: {
    handleSaveNewTopic() {
      this.controller.handleSaveNewTopic();
    },
    handleAddToExistingTopic() {
      this.controller.handleAddToExistingTopic();
    },
    handleCompareMetrics() {
      this.controller.handleCompareMetrics();
    },
    handleMergeTopics() {
      this.controller.handleMergeTopics();
    },
    handleMoreBtns() {
      this.$refs.buttonPopupMenu.handleClick();
    }
  },

  mounted() {
  }
}
</script>

<style lang="scss">
.wy-interactions-contact-reasons-page-action-buttons {
  .overlapping-header {
    position: absolute;
    // top: 125px;
    // left: 55px;
    // width: calc(100% - 56px);
    // height: 99px;
    top: 110px;
    left: 0px;
    width: calc(100%);
    height: 50px;

    background-color: #FFF;
    z-index: 8;
    display: flex;
    align-items: center;
    border-top-right-radius: 10px;

    .col-left {
      width: 150px;
      font-size: 14px;
      font-weight: 700;
      text-align: left;
    }
    .col-right {
      width: calc(100% - 150px);
      .button.section {
        text-align: right;
        // margin-right: 20px;
        display: flex;
        justify-content: flex-end;
        flex-direction: row;
        gap: 5px;

        .primary-btn.acknowledge-btn {
          width: 135px;
          .button-text {
            left: -8px;
          }
        }
        .primary-btn.see-more-btn > span {
          left: -12px;
        }
        .button-icon.circle-help {
          position: absolute;
          display: flex;
          width: 17px;
          height: 17px;
          background-image: url('../../../assets/icons/icon_circle-help.svg');
          background-repeat: no-repeat;
          background-size: 17px;
          top: 3px;
          left:83px;
        }
        .see-more-btn {
          color: #FFF;
          width: 35px;
        }
        .see-more-btn.is-disabled {
          > span {
            cursor: not-allowed;
          }
          .btns-pop-over-menu.el-dropdown {
            pointer-events: none;
          }
        }
        .see-more-btn.is-disabled:hover {
          cursor: not-allowed;
        }
        span.button-text.see-more-btn {
          bottom: 2px;
        }
        .btns-pop-over-menu.el-dropdown {
          // left: -12px;
        }
      }
    }
  }
}
.interactions-dashboard-btns-dropdown-menu {
  .el-dropdown-menu__item {
    font-size: 14px;
    color: var(--site-font-secondary-color);
    // padding: 10px 20px;
    &:hover {
      // background-color: var(--site-button-primary-btn-hover-background-primary-color);
      color: #000;
    }
  } 
}
</style>
